import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FillBox from "../FillBox";
import { Box } from "@mui/system";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import "../../../styles/components.css";
import axios from "axios";
import { getURLBase, updateHeightAfterContentUpdate, updateParentHeight } from "../../../utils/helperFns";
import { Button, CircularProgress, Container, Divider, Grid, IconButton } from "@mui/material";

import { SavingsEnvelopesImages } from "../../../utils/mockData";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const images = SavingsEnvelopesImages;

export class SavingEnvelopeList extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/envelopes"
        this.state = {
            isReady: false,
            showSavingsEnvelope: false,
            showCreateNewEnvelope: false,
            showInvestmentEnvelope: false,
            open: false,
            msg: ""
        }
    }
    componentDidMount() {
        if (!this.state.isReady) {
            axios.post(this.url, { gid: this.props.gid }).then(
                (response) => {
                    var investment = response.data.body.envelopes.pop();
                    this.setState(response.data.body)
                    this.setState({ investmentEnv: investment })
                    this.setState({ isReady: true });
                }
            )
        }
    }

    refreshEnvelopes = () => {
        axios.post(this.url, { gid: this.props.gid }).then(
            (response) => {
                var investment = response.data.body.envelopes.pop();
                this.setState(response.data.body)
                this.setState({ investmentEnv: investment })
                this.setState({ isReady: true });
            }
        )
    }

    toggleOpen = (msg, secondMsg = null, img="success.gif") => {
        this.setState({ open: !this.state.open, msg: msg, secondMsg: secondMsg, img: img });
    }
    handleBoxClose = () => {
        this.setState({ open: false });
    };

    onWithdraw = (env, toenv) => {
        axios.post('https://5xzfhwwvk3.execute-api.eu-west-2.amazonaws.com/v1/transfer_between_env', {
            gid: this.props.gid,
            amount: this.props.amount,
            fromenv: env,
            toenv: toenv
        }).then(res => {
            console.log("response: ", res);
            const is_failed = res.data.status == "failed";
            if (is_failed) {
                this.toggleOpen("This operation cannot be completed at ","this time as your earlier operation is in progress.", "error.png")

            } else {
                this.toggleOpen("The transfer has been initiated. This action will", " be completed soon. Look out for an email!");
            }

            setTimeout(() => {
                this.toggleOpen("");
                this.props.toggleHandler();
            }, 6251);

        }
        ).catch(err => {
            console.log(err);
        });
        
    }

    toggleInvestmentsEnvelopeHandler = () => {
        var show = this.state.showInvestmentEnvelope;
        show = !show;
        this.setState({ showInvestmentEnvelope: show },
            () => {
                updateParentHeight("parent_SavingEnvelopes", "child_InvestmentsEnvelope", this.state.showInvestmentEnvelope);
            });
    }

    toggleSavingsEnvelopeHandler = () => {
        var show = this.state.showSavingsEnvelope;
        show = !show;
        this.setState({ showSavingsEnvelope: show },
            () => {
                updateParentHeight("parent_SavingEnvelopes", "child_SavingEnvelope", this.state.showSavingsEnvelope);
            });
    }

    render() {

        return (
            <Card className="popup" id="child_SavingEnvelopeList">
                <Container className="popupHeader">

                    <Typography variant="h4" fontWeight={700} align="center" gutterBottom>Withdraw amount to other envelopes</Typography>
                </Container>
                <Divider light />
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                {this.state.isReady ?
                    <CardContent sx={{ paddingY: 3 }} className="popupBody">
                        <Box pt={{ xs: 10, sm: 0 }}>
                            <Grid container justifyContent="center" rowGap={2} columnSpacing={{ xs: 2, sm: 7 }} padding="0 1vw">
                                {this.state.envelopes.map((i, index) =>
                                    <Grid key={index} item md={3} sm={4} xs={6} display="flex" className={`${(i.saved === null) ? "blur " : ""}`} >
                                        <Button
                                            onClick={() => { this.setState({ env_id: i.env_id }); this.onWithdraw(this.props.env_id, i.env_id) }}
                                            variant="text"
                                            sx={{ width: "100%", padding: 0 }}>
                                            <FillBox id={i.env_id} env_id={this.state?.env_id} category={i.category} saved={i.saved} target={i.target} image={images[i.icon]}
                                            />
                                        </Button>
                                        {updateHeightAfterContentUpdate(this.props.parent, "child_SavingEnvelopeList", "parent_SavingEnvelopes")}

                                    </Grid>

                                )}
                            </Grid>
                        </Box>
                        <Dialog
                            open={this.state.open}
                            onClose={this.handleBoxClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            sx={{ borderRadius: "30px" }}
                        >
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description" className="font-medium">
                                    {/* <div > */}

                                    <img src={`/${this.state.img}`} style={{ display: "block", margin: "auto" }} alt="" />
                                    <p style={{ marginTop: "-20px", margin: "auto", textAlign: "center", fontWeight: 900 }}>{this.state.msg}{
                                        this.state.secondMsg ? (<><br /> {this.state.secondMsg} </>) : null
                                    }</p>
                                    {/* </div> */}
                                </DialogContentText>
                            </DialogContent>
                        </Dialog>
                    </CardContent>

                    : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>
                }

            </Card>
        );
    }
}

export default SavingEnvelopeList;